import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import { resolveAuthPanelContent } from '@/config/authPanelContent';
import { useLocation } from 'react-router-dom';

export function AuthAsidePanel() {
  const { pathname } = useLocation();
  const content = resolveAuthPanelContent(pathname);

  return (
    <div className="relative z-10 flex h-full flex-col justify-between px-12 py-12">
      <div>
        <p className="text-sm font-medium uppercase tracking-widest text-violet-200/90">{content.eyebrow}</p>
        <h1 className="mt-4 text-4xl font-bold tracking-tight text-white xl:text-5xl">{content.heading}</h1>
        <p className="mt-5 max-w-md text-lg leading-relaxed text-slate-200/95">{content.description}</p>
        <ul className="mt-8 max-w-md space-y-3">
          {content.highlights.map((item) => (
            <li key={item} className="flex gap-3 text-sm leading-relaxed text-slate-100/95">
              <CheckCircleOutlineIcon className="mt-0.5 shrink-0 text-violet-300" sx={{ fontSize: 18 }} />
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}
